/**
 * This helper class gives the sample sizes.
 */
export class SampleSizeHelper {

  constructor(
    private sampleSize: number,
    private sampleSizes: number[],
  ) {}

  getSampleSize(sampleIndex: number): number {
    return this.sampleSize !== 0
      ? this.sampleSize
      : this.sampleSizes[sampleIndex];
  }

}
